export const AppConfig = {
  production: false,
  environment: 'PROD',
  hmr: false,
  baseHref: '/',
  API_BACKAND_SERVER: 'http://license:5050'
};

